import { useParams } from "react-router-dom";
import { nameOf } from "../../Utils/nameOf";
import { SupplierFormTabs } from "./SupplierFormTabs";
import { useFetchSupplier } from "../Hooks/useFetchSupplier";
import { useUpdateSupplier } from "../Hooks/useUpdateSupplier";
import Supplier from "../Supplier";
import { useDeleteSupplier } from "../Hooks/useDeleteSupplier";
import { supplierDefaultValues } from "./supplierDefaultValues";

export const EditSupplier = () => {
  const { supplierId } = useParams();
  const { data: supplier } = useFetchSupplier(supplierId);
  const { mutate: updateSupplier } = useUpdateSupplier(supplierId);
  const { mutate: deleteSupplier } = useDeleteSupplier(supplierId);

  const disabledFields: Array<string> = [
    nameOf<Supplier>("Gsdb"),
    nameOf<Supplier>("CountryCode"),
    nameOf<Supplier>("MGLongitude"),
    nameOf<Supplier>("MGLatitude"),
    nameOf<Supplier>("AltCountryCode"),
    nameOf<Supplier>("AltMGLatitude"),
    nameOf<Supplier>("AltMGLongitude"),
  ];

  return (
    <SupplierFormTabs
      title="Edit Supplier"
      supplier={supplier ?? supplierDefaultValues}
      onSave={(it: Supplier) => {
        updateSupplier(it);
      }}
      onDelete={() => deleteSupplier(supplierId)}
      disabledField={disabledFields}
    />
  );
};
